import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=60dd4eb3&"
import script from "./Passenger.vue?vue&type=script&lang=js&"
export * from "./Passenger.vue?vue&type=script&lang=js&"
import style0 from "./Passenger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/agent_x64/_work/4/s/TravelportTH/Responsive GO/galileo-online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSlideXReverseTransition } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAlert,VAutocomplete,VCard,VContainer,VExpansionPanel,VExpansionPanelContent,VFlex,VForm,VLayout,VSelect,VSlideXReverseTransition,VSpacer,VSwitch,VTextField,VTextarea})
